import { useContext } from 'react';
import FeatureFlagsContext from '../context/FeatureFlagsContext';

const useFeatureFlags = () => useContext(FeatureFlagsContext);

export default useFeatureFlags;
